import commonIconClose1 from "./icons/comon-icon-close/close1";
import commonIconClose2 from "./icons/comon-icon-close/close2";
import commonIcoinComplete1 from "./icons/common-icon-complete/complete1";
import commonIcoinComplete2 from "./icons/common-icon-complete/complete2";
import commonIconSave from './icons/common-icon-save';
import commonIconAdd1 from './icons/common-icon-add/add1';
import commonIconAdd2 from './icons/common-icon-add/add2';
import commonIconCollect from './icons/common-icon-collect';
import commonIconDate from './icons/common-icon-date';
import commonIconDelete from './icons/common-icon-delete';
import commonIconDownload from './icons/common-icon-download';
import commonIconEdit1 from './icons/common-icon-edit/edit1';
import commonIconEdit2 from './icons/common-icon-edit/edit2';
import commonIconEmail from './icons/common-icon-email';
import commonIconEye from './icons/common-icon-eye';
import commonIconFile from './icons/common-icon-file';
import commonIconFilter from './icons/common-icon-filter';
import commonIconFolder from './icons/common-icon-folder';
import commonIconFolderOpen from './icons/common-icon-folderOpen';
import commonIconHidden from './icons/common-icon-hidden';
import commonIconQuestion from "./icons/common-icon-question";
import commonIconRemove1 from './icons/common-icon-remove/remove1';
import commonIconRemove2 from './icons/common-icon-remove/remove2';
import commonIconSearch from './icons/common-icon-search';
import commonIconSetting from './icons/common-icon-setting';
import commonIconShare from './icons/common-icon-share';
import commonIconSort from './icons/common-icon-sort';
import commonIconTime from './icons/common-icon-time';
import commonIconUpload from './icons/common-icon-upload';
import commonIconUser from './icons/common-icon-user';
import commonIconWarn from './icons/common-icon-warn';

export default [
    commonIconClose1, commonIconClose2, commonIcoinComplete1, commonIcoinComplete2, commonIconSave, commonIconAdd1, commonIconAdd2, commonIconCollect,
    commonIconDate, commonIconDelete, commonIconDownload, commonIconEdit1, commonIconEdit2, commonIconEmail, commonIconEye, commonIconFile,
    commonIconFilter, commonIconFolder, commonIconFolderOpen, commonIconHidden, commonIconQuestion, commonIconRemove1, commonIconRemove2, commonIconSearch,
    commonIconSetting, commonIconShare, commonIconSort, commonIconTime, commonIconUpload, commonIconUser, commonIconWarn
];
